import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ee71f48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "record" }

import { SignalRNotification } from "@/types/notifications/SignalRNotification";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'notification-card',
  props: {
  /***
   * Notification to be displayed
   * @type {SignalRNotification}
   * @required
   */
  notification: {
    type: Object as PropType<SignalRNotification>,
    required: true,
  },
  /***
   * Index of the notification in the parent array
   * @type {Number}
   * @required
   */
  index: {
    type: Number,
    required: true,
  },
  /***
   * Background colour of the card
   * @type {String}
   * @required
   */
  backgroundColor: {
    type: String,
    required: true,
  },
},
  emits: [
  /** Triggers when the user clicks the remove icon */
  "removeClicked",
  /** Triggers when the user clicks on the notification */
  "notificationClicked",
],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "f7f969b4": (props.backgroundColor)
}))





const onRemoveClicked = (notification: SignalRNotification, index: number) =>
  emit("removeClicked", notification, index);

const onNotificationClicked = (notification: SignalRNotification) =>
  emit("notificationClicked", notification);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: "fa-regular fa-circle-xmark",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (onRemoveClicked(__props.notification, __props.index)))
    }),
    _createElementVNode("div", {
      class: "title",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (onNotificationClicked(__props.notification)))
    }, _toDisplayString(__props.notification.title), 1),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (onNotificationClicked(__props.notification)))
    }, _toDisplayString(__props.notification.message), 1)
  ]))
}
}

})